import React from 'react';

import { BasicAlert, type BasicAlertProps } from './BasicAlert';
import { CollapsibleAlert, type CollapsibleAlertProps } from './CollapsibleAlert';
import { XOR } from './types';

export type AlertProps = XOR<BasicAlertProps, CollapsibleAlertProps> & {
    collapsible: boolean;
};

function isComponentCollapsible(
    props: Omit<AlertProps, 'collapsible'>,
    collapsible: boolean
): props is CollapsibleAlertProps {
    return collapsible;
}

const Alert = ({ collapsible, ...props }: AlertProps) => {
    return isComponentCollapsible(props, collapsible) ? (
        <CollapsibleAlert {...props} />
    ) : (
        <BasicAlert {...props} />
    );
};

export default Alert;
